import { render } from "./CheckSvg.vue?vue&type=template&id=3b1dd3c5"
const script = {}

import exportComponent from "X:\\Project\\Client\\RealnessDigital\\Dev\\Firebase\\filez\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__